export default {
  "dashboard.widget.feedback.unappetizing":
    "Produkt trifft nicht meinen Geschmack",
  "dashboard.widget.feedback.interested": "Produkt interessant",
  "dashboard.widget.feedback.no_price_fit": "Preis-Leistung stimmt nicht",
  "dashboard.widget.feedback.other_reason": "Sonstiges Feedback",
  "dashboard.widget.feedback.missing": "Musterbestellung fehlt",
};
